import Vue from 'vue'
import Vuex from 'vuex'
import api from '../api'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    productData: [], //产品中心商品列表
    brandList:[],   //产品中心品牌
    classifyType: [], //产品中心分类
    isLogin: false, 
    threeData:[], //三级菜单
    itemData:[], //四级菜单
    AllNum:0,  //总价
    flag:false,
    learnningFlag:false,
    serviceList:[] ,//技术服务列表
    productLeftName:[46],
    currentIndex:'four',
    page: 1,
    limit: 10,
    total:0,
    category_id:'',
    currentBrandIndex:"",
    whether_addressStatus:true, //是否同收货地址的状态
  },
  mutations: {
    userState(state, flag) {
      state.isLogin = flag
    },
    getServeList(state,payload){
      state.serviceList=payload
    }
  },
  actions: {  
    userLogin({ commit }, flag) {
      commit('userState', flag)
    },
    setServeList({commit}){
      api.technicalServise.serviseList().then(({data})=>{
        commit('getServeList',data)
     })
    }
  },
  modules: {
  }
})
